import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const useGetList = (
  schoolId,
  trainingId,
  accessToken,
  page = 1,
  pageSize = 30,
  filter
) => {
  return useQuery(
    ["sessions", schoolId, trainingId, accessToken, page, pageSize, filter],
    async () => {
      // start_date and end_date are already in YYYY-MM-DD format from the frontend
      let startDate = filter?.start_date ? String(filter?.start_date).split("T")[0] : "";
      let endDate = filter?.end_date ? String(filter?.end_date).split("T")[0] : "";
      if (schoolId && trainingId) {
        try {
          const response = await fetch(
            BACKEND_URL +
            `/api/v1/schools/${schoolId}/trainings/${trainingId}/courses-sessions?page=${page}&pageSize=${pageSize}&start_date=${startDate || ""
            }&end_date=${endDate || ""}&level_id=${filter?.level_id || ""
            }&class_id=${filter?.classe_id || ""}&course_id=${filter?.course_id || ""
            }&teacher_id=${filter?.teacher_id || ""}&classroom_id=${filter?.classroom_id || ""
            }`,
            {
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + accessToken,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch sessions! " + response.statusText);
          }
          if (response.status >= 299) {
            throw new Error(
              "Erreur de récupération de la liste des séances de cours!"
            );
          }
          const levels = await response.json();
          return levels;
        } catch (error) {
          // Handle the error
          console.error("Error fetching sessions:", error);
          throw error;
        }
      }
    }
  );
};

const GetOne = (schoolId, trainingId, accessToken, sessionId) => {
  return useQuery(
    ["session", schoolId, trainingId, accessToken, sessionId],
    async () => {
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/courses-sessions/${sessionId}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Erreur de récupération de la séance de cours!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        throw error;
      }
    }
  );
};

const CreateOne = async (schoolId, trainingId, accessToken, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/courses-sessions",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de création de la séance de cours!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateOne = async (
  schoolId,
  trainingId,
  accessToken,
  sessionId,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/courses-sessions/" +
      sessionId,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de création de la classe!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteOne = async (schoolId, trainingId, accessToken, sessionId) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/courses-sessions/" +
      sessionId,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de suppression de la séance de cours!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const sessionsAPI = {
  useGetList,
  GetOne,
  CreateOne,
  UpdateOne,
  DeleteOne,
};

export default sessionsAPI;
